import { useLocation } from "react-router-dom";
import emailjs from "@emailjs/browser";
import EmailForm from "../../components/EmailForm/EmailForm";
import Buttons from "../../components/Buttons/Buttons";
import { useState, useRef } from "react";
import Footer from "../../components/Footer/Footer";

const ConfirmPricing = ()=> {
    const location = useLocation();
    const stats = location.state || {};
    const [emailInfo, setEmailInfo] = useState({
        firstName: '',
        lastName: '',
        email_from: '',
        jobTitle: '',
        organization: ''
    })
    const publicDomains = ['gmail.com', 'yahoo.com', 'hotmail.com', 'outlook.com'];
    const [errMessage, setErrMessage] = useState('');
    const formRef = useRef();

    const validEmail = (email) => {
        const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return re.test(String(email).toLowerCase());
    };
    const handleChange = (e) => {
        const {name, value} = e.target;
        setEmailInfo({
            ...emailInfo,
            [name]:value
        });
    }
    const formatNumber = (num) => {
        if (!num) return "0";
        return parseFloat(num).toLocaleString("en-US", {maximumFractionDigits: 2});
    }

    const isValidateForm = (emailInfo)=>{
        return (emailInfo.firstName.trim() && emailInfo.lastName.trim() && emailInfo.email_from &&
                emailInfo.jobTitle && emailInfo.organization);
    }
    
    const onClickSubmit = async (e)=> {
        e.preventDefault();
        
        // Validate form fields 
        if (!isValidateForm(emailInfo)){
            setErrMessage("Please fill in all fields correctly.");
            return;
        }
        // Validate email format
        if(!validEmail(emailInfo.email_from)) {
            setErrMessage("Invalid Email Address");
            return;
        }
        // check if it's business email
        const emailDomain = emailInfo.email_from.split('@')[1];
        if (publicDomains.includes(emailDomain)) {
            setErrMessage("Please use a business email address");
            return;
        }
        setErrMessage("");

        await emailjs.sendForm(process.env.REACT_APP_SERVICE_ID, process.env.REACT_APP_TEMPLATE_ID, formRef.current, process.env.REACT_APP_PUBLIC_KEY)
        .then(
            (response) => {
              console.log('SUCCESS!', response.status, response.text);
            },
            (error) => {
              console.log('FAILED...', error);
            },
        );
        window.location.replace('https://vlenergy.ca/')
    }
    return (
        <div className="main">
            <form ref={formRef} onSubmit={onClickSubmit}>
                <div className="gallery">
                    <h3 className="gallery__headTitle">Receive Price Indication By Email</h3>
                    <div className="gallery__parent">
                        <EmailForm emailInfo={emailInfo} onChange={handleChange} errMessage={errMessage} />
                    </div>
                    <input type="hidden" name="cems" value={formatNumber(stats.cems)} />
                    <input type="hidden" name="cemsUnit" value={stats.cemsUnit} />
                    <input type="hidden" name="rata" value={formatNumber(stats.rata)} />
                    <input type="hidden" name="rataUnit" value={formatNumber(stats.rataUnit)} />
                    <input type="hidden" name="cga" value={formatNumber(stats.cga)} />
                    <input type="hidden" name="cgaUnit" value={formatNumber(stats.cgaUnit)} />
                    <input type="hidden" name="daily" value={formatNumber(stats.daily)} />
                    <input type="hidden" name="dailyUnit" value={formatNumber(stats.dailyUnit)} />
                    <input type="hidden" name="maintenanceCost" value={formatNumber(stats.maintenanceCost)} />
                    <input type="hidden" name="maintenanceUnit" value={stats.maintenanceUnit} />
                    <input type="hidden" name="das" value={formatNumber(stats.das)} />
                    <input type="hidden" name="totalAcost" value={formatNumber(stats.totalAcost)} />
                    <input type="hidden" name="monthlyCost" value={formatNumber(stats.totalAcost / 12)} />
                    <Buttons buttonText={"Submit"} onClick={onClickSubmit}/>
                </div>
            </form>
            <Footer />
        </div>
    )
}

export default ConfirmPricing;